<btw-academy-header/>
<div class="app-container about-values pt-4 pb-5">
  <h2>BMW TechWorks Academy</h2>
  <p class="mt-4 about-text">
    Die BMW TechWorks Romania Academy ist die Bildungs- und Entwicklungsplattform von BMW TechWorks Romania, die geschaffen wurde, um eine starke Verbindung zwischen der akademischen Welt und der realen Technologiewelt herzustellen.
    Ziel der Akademie ist es, eine neue Generation von Fachkräften in den Bereichen IT, Softwareentwicklung und Automobiltechnologie auszubilden und ihnen Zugang zu Mentoren, Ressourcen und praxisnahen Lernerfahrungen in einem kollaborativen Umfeld zu bieten.
  </p>

  <p class="about-text">
    Durch Mentoring-Programme, Praktika und Weiterbildungsinitiativen unterstützt die Akademie Studierende und junge Fachkräfte beim erfolgreichen Einstieg in technische Berufsfelder.
    Zu den Aktivitäten gehören praxisorientierte Schulungen, thematische Workshops, interdisziplinäre Projekte, Innovationsveranstaltungen und Kooperationen mit Universitäten in Rumänien und im Ausland.
  </p>

  <p class="about-text">
    Die Mission der BMW TechWorks Romania Academy ist es, zukunftsorientierte Kompetenzen zu fördern, technologische Kultur zu stärken und ein Bildungsökosystem zu schaffen, in dem Ideen, Forschung und Innovation zusammenkommen.
    Ein Ort, an dem Leidenschaft für Technologie zu beruflicher Exzellenz und verantwortungsbewusstem Leadership wird.
  </p>
</div>

<div class="app-container our-values pb-5 pt-5">
  <div class="btw-academy-cards">
    @for (item of infoCards; track item.title) {
      <box-item-flip
        [content]="item.content"
        [description]="item.description"
        [imgClass]="item.imgClass"
        [title]="item.title"
        [url]="item.url">
      </box-item-flip>
    }
  </div>
</div>
